import { AxiosResponse, isAxiosError } from 'axios';
import createAxiosInstance from '../middlewares/axios.interceptors';

const paymentUrl = '/folha-pagamento';

export const PaymentSheetService = {
  getPayments: async () => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.get(paymentUrl + '/list');
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  getPaymentSheet: async (id: string, date: string) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.get(paymentUrl + '/retorna-folha', {
        params: {
          data: date,
          cod_folha: id
        }
      });
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  createPayment: async (data: any) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.post(paymentUrl + '/create', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  updatePayment: async (data: any) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.post(paymentUrl + '/update', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  deletePayment: async (id: string) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.delete(paymentUrl + '/delete', {
        params: {
          id
        }
      });
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  },

  printPayment: async (id: string) => {
    const axiosInstance = createAxiosInstance();

    try {
      return await axiosInstance.get(paymentUrl + '/print', {
        params: {
          id
        }
      });
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        throw err.response as AxiosResponse;
      }
    }
  }
};
